import React, { useMemo, useRef, useState } from 'react';
import { Box, Card, Typography, TextField, Button, Stack } from '@mui/material';
import apkService from '../services/apkService';

function inferApiBaseFromPanel() {
  try {
    const url = new URL(window.location.href);
    const host = url.hostname; // e.g. panel.example.com
    const parts = host.split('.');
    if (parts.length >= 2) {
      parts[0] = 'api';
      const apiHost = parts.join('.');
      return `${url.protocol}//${apiHost}`;
    }
    return `${url.protocol}//${host}`;
  } catch {
    return '';
  }
}

const ApkBuilder = () => {
  const inferredBase = useMemo(() => inferApiBaseFromPanel(), []);
  const [appName, setAppName] = useState('Telegram Launcher');
  const [packageName, setPackageName] = useState('com.example.telegramlauncher');
  const [baseApiUrl, setBaseApiUrl] = useState(inferredBase);
  const [loading, setLoading] = useState(false);
  const fileRef = useRef(null);

  const handleBuild = async () => {
    try {
      setLoading(true);
      const iconFile = fileRef.current?.files?.[0] || null;
      const response = await apkService.buildApk({ appName, baseApiUrl, packageName, iconFile });

      // Скачать blob как файл
      const blob = new Blob([response.data], { type: 'application/vnd.android.package-archive' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${packageName || 'app'}-release.apk`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      alert(`Ошибка сборки APK: ${e?.response?.data?.error || e.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h5" mb={2}>Сборка APK лаунчера</Typography>
      <Card sx={{ p: 3 }}>
        <Stack spacing={2}>
          <TextField label="Название приложения" value={appName} onChange={e => setAppName(e.target.value)} fullWidth />
          <TextField label="Package Name" value={packageName} onChange={e => setPackageName(e.target.value)} fullWidth />
          <TextField label="BASE_API_URL" value={baseApiUrl} onChange={e => setBaseApiUrl(e.target.value)} fullWidth helperText="Обычно это адрес админки с поддоменом api (например, https://api.example.com)" />
          <Button variant="outlined" component="label">
            Загрузить иконку (PNG/JPG)
            <input ref={fileRef} hidden type="file" accept="image/png,image/jpeg" />
          </Button>
          <Box>
            <Button variant="contained" onClick={handleBuild} disabled={loading || !baseApiUrl}>
              {loading ? 'Собираем...' : 'Собрать и скачать APK'}
            </Button>
          </Box>
        </Stack>
      </Card>
    </Box>
  );
};

export default ApkBuilder;
